// OfferCard.jsx
import React from "react";
import { FileText } from "lucide-react";

const OfferCard = ({ offer, isExpanded, onExpand, handleClick }) => {
  const horizontalLogo = offer?.banking_partners_hl || offer?.logo_image_url;

  const verticalLogo = offer?.banking_partners_vl || offer?.logo_image_url;

  return (
    <div
      className={`w-full  backdrop-blur-lg rounded-[20px] shadow-md border-[1px] border-[#009477] transition cursor-pointer 
      ${isExpanded ? "p-4 bg-[#aef4e6]" : "py-3 px-4 bg-[#006F59]"} `}
      onClick={onExpand}
    >
      {/* ---------- TOP SECTION ---------- */}
      {isExpanded && (
        <img src={horizontalLogo} alt="lender" className="w-32 mx-auto" />
      )}

      <div className="flex items-center justify-between">
        {/* Collapsed State UI */}
        {!isExpanded && (
          <div className="flex items-center space-x-4">
            <img
              src={verticalLogo}
              className="w-[60px] h-[60px] object-cover"
              alt="logo"
            />

            <div>
              <p className="text-sm text-[#FFFFFF]">Pre-Approved Amount:</p>
              <p className="text-lg font-semibold text-[#FFFFFF]">
                 {offer?.credit_limit.includes("to")?"":"upto "}{" "}₹{offer?.credit_limit}
              </p>
            </div>
          </div>
        )}

        {/* Expand Arrow */}
        {!isExpanded && (
          <img
            src="/assets/img/Group 240.png"
            className="w-[29px] h-[29px]"
            alt="arrow"
          />
        )}
      </div>

      {/* ---------- EXPANDED STATE ---------- */}
      {isExpanded && (
        <>
          <hr className="my-2" />

          {/* Pre-Approved Amount */}
          <div className="flex gap-2 text-gray-800">
            <span className="font-atkinson">
              {offer?.is_max ? "Max Loan Amount:" : "Pre-Approved Amount:"}
            </span>
            <span className="font-semibold">{offer?.credit_limit.includes("to")?"":"upto "}{" "}₹{offer?.credit_limit}</span>
          </div>

          <hr className="my-2" />

          {/* Tenure */}
          <p className="text-gray-700">Tenure: {offer?.tenure || 48} Months</p>

          <hr className="my-2" />

          {/* Interest Rate */}
          {offer?.interest_rate && (
            <>
              <p className="text-gray-700">
                Interest Rate: {offer?.interest_rate}
              </p>
              <hr className="my-2" />
            </>
          )}

          {/* Processing Fees */}
          {offer?.processing_fee && (
            <>
              <p className="text-gray-700">
                Processing Fees: {offer?.processing_fee}
              </p>
              <hr className="my-2" />
            </>
          )}

          {/* Extra Loan Details */}
          <div className="text-sm text-gray-700 space-y-2">
            {offer?.apr && (
              <div className="flex justify-between">
                <span className="font-semibold">APR:</span>
                <span>{offer?.apr}</span>
              </div>
            )}

            {offer?.penal_charges && (
              <div className="flex justify-between">
                <span className="font-semibold">Penal Charges:</span>
                <span>{offer?.penal_charges}</span>
              </div>
            )}

            {offer?.kfs_doc && (
              <div className="flex justify-between items-center ">
                <span className="font-semibold">View KFS:</span>
                <a
                  href={offer?.kfs_doc}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center text-green-700 hover:underline"
                >
                  <FileText className="w-4 h-4 mr-1" />
                  Document
                </a>
              </div>
            )}
          </div>

          {/* ---------- CTA BUTTON ---------- */}
          <button
            className="mt-4 w-full bg-black text-white py-2.5 rounded-lg flex justify-center items-center gap-2 tracking-wide"
            onClick={(e) => {
              e.stopPropagation();
              handleClick();
            }}
          >
            Get Offer
            <img
              src="/assets/img/Get offer CTA icon.svg"
              alt="arrow"
              className="w-4"
            />
          </button>
        </>
      )}
    </div>
  );
};

export default OfferCard;
